import type { Params } from './build-paths.util';

export const buildPath = (path: string, params: Params): string =>
  Object.entries(params).reduce(
    (curr, [paramKey, paramValue]) =>
      paramValue ? curr.replace(`:${paramKey}`, paramValue) : curr,
    path,
  );
